export default [
  {
    value: 'under20k',
    text: 'Less than $20,000',
  },
  {
    value: '20to35k',
    text: '$20,000 - $34,999',
  },
  {
    value: '35to50k',
    text: '$35,000 - $49,999',
  },
  {
    value: '50to75k',
    text: '$50,000 - $74,999',
  },
  {
    value: '75to100k',
    text: '$75,000 - $99,999',
  },
  {
    value: '100to150k',
    text: '$100,000 - $149,999',
  },
  {
    value: '150to200k',
    text: '$150,000 - $199,999',
  },
  {
    value: 'over200k',
    text: '$200,000 or more',
   }
]
